<template>
  <div v-if="timeCodes.length > 0" id="timeCode-list" class="table-responsive">
    <table class="table table-striped table-hover-pink" role="grid">
      <thead>
        <tr>
          <th>{{ $t('models.time_code.name') }}</th>
          <th>{{ $t('models.time_code.start_time') }}</th>
          <th>{{ $t('models.time_code.end_time') }}</th>
          <th>{{ $t('models.time_code.effective_work_minutes') }}</th>
          <th class="actions">{{ $t('table.headers.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <time-codes-table-row v-for="timeCode in timeCodes" :timeCode="timeCode" :key="timeCode.id"></time-codes-table-row>
      </tbody>
    </table>
  </div>
</template>

<script type="text/javascript">
  import { mapActions, mapGetters } from 'vuex'
  import TimeCodesTableRow from './TimeCodesTableRow'

  export default {
    name: 'TimeCodeTable',
    components: {
      TimeCodesTableRow
    },
    props: { entityId: Number },
    watch: {
      entityId: function(value) {
        this.loadList(value)
      }
    },
    computed: {
      ...mapGetters({
        timeCodes: 'timeCodes/timeCodeList'
      }),
    },
    methods: {
      ...mapActions({
        loadList: 'timeCodes/loadList'
      })
    },
    mounted: function() {
      this.loadList(this.entityId)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/timeCodes/TimeCodesTable.vue